module.exports = __webpack_public_path__ + "static/img/modal-error.f3572b63.png";